import { render, staticRenderFns } from "./CoComment.vue?vue&type=template&id=2f42a37d&scoped=true&"
import script from "./CoComment.vue?vue&type=script&lang=ts&"
export * from "./CoComment.vue?vue&type=script&lang=ts&"
import style0 from "./CoComment.vue?vue&type=style&index=0&id=2f42a37d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f42a37d",
  null
  
)

export default component.exports